<template>
  <router-view/>
</template>

<script>
import store from '@/store';
import detector from '@/utils/mobileDetector';
import { mapGetters } from 'vuex';

export default {
  name: 'Order',
  beforeRouteEnter(to, from, next) {
    store
      .dispatch('project/load', { order: to.params.order, theme: to.query.theme })
      .then(() => {
        store.dispatch('exteriors/toggleShowOverlayStatus', detector.mobile()
          ? !store.getters['project/statusSwitchMobileOff']
          : store.getters['project/statusSwitch']);

        return store.dispatch('project/loadTranslations', to.params.order);
      })
      .then(() => next());
  },
  computed: {
    ...mapGetters('service', ['primaryColor']),
  },
  watch: {
    primaryColor(value) {
      this.setPrimaryColor(value);
    },
  },
  created() {
    this.setPrimaryColor(this.primaryColor);
  },
  methods: {
    setPrimaryColor(value) {
      if (value) {
        this.$vuetify.theme.themes.light.primary = value;
        this.$vuetify.theme.themes.light.accent = value;
        this.$root.$el.style.setProperty('--primary-color', value);
      }
    },
  },
};
</script>
